import { CircleDashedIcon, LockSimpleIcon, MinusIcon, StarIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import type { CriterionStrength } from '@entities/search-session';

import styles from './Criteria.module.css';

const ICONS = {
  required: LockSimpleIcon,
  preferred: StarIcon,
  none: MinusIcon,
  unset: CircleDashedIcon,
} as const;

/**
 * Метка критерия: обязательно / желательно / без предпочтений (MVP_PRD §11).
 *
 * Четвёртое состояние — «ещё не уточняли»: его нельзя показывать как «без
 * предпочтений», иначе незаданный критерий выглядел бы решением пользователя.
 *
 * Цвет не единственный носитель смысла: у каждой метки есть текст и иконка
 * (CLAUDE.md §8).
 */
export function StrengthTag({ strength }: { strength: CriterionStrength }) {
  const { t } = useTranslation();
  const Icon = ICONS[strength];

  return (
    <span className={[styles.tag, styles[`tag-${strength}`]].filter(Boolean).join(' ')}>
      <Icon size={12} weight="bold" aria-hidden="true" />
      {t(`criteria.strength.${strength}`)}
    </span>
  );
}
